import React from 'react';

import {connect} from "react-redux";
import Loader from "../common/Loader";
import sematable, {Table} from "sematable";
import {Button,NavItem} from "react-materialize";
import l10n from "../../l10n/localization";
import * as creationActions from "../../actions/creation";
import * as portActions from "../../actions/port";
import PortForm from "../forms/PortForm";
import Dropdown from "../common/Dropdown";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export const PORTS_TABLE = 'PORTS_TABLE';

const columns = [
    { key: 'id', header: 'ID', primaryKey: true, hidden: true},
    { key: 'name', header: l10n.port.name, searchable: true, filterable: true, sortable: true},
    { key: 'countryName', header: l10n.port.country, searchable: true, filterable: true, sortable: true},
    { key: 'actions', header: ''}
];

/**
 * Table
 */
class PortsTable extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            portID: null,
            dialogActive: false
        };
    }

    handleDelete = () => {
        this.props.dispatch(portActions.deletePort(this.state.portID));
    };

    addActions() {
        this.props.columns[this.props.columns.length - 1].Component = ({row}) => {
            return (
                <div className="fog-table-buttons commodities-button">
                    {<Dropdown trigger={(props) => (
                        <Button floating icon="more_vert" className="more-button" onClick={props.onClick}/>)}>
                        <NavItem>
                            <Button disabled={this.props.deletingPort} className="transparent" onClick={() => this.setState({...this.state, dialogActive: true, portID: row.id})} >
                                {l10n.common.remove}
                            </Button>
                        </NavItem>
                    </Dropdown>}
                    <Button floating onClick={() => this.props.handleClick(PortForm, {item: row}, creationActions.destroyingnewlyCreatedPort())} icon="edit" className="edit-button" />
                </div>
            )
        };
    }

    render() {
        this.addActions();

        return (
            <div>
                <Table  {...this.props} data={this.props.data} />
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false, portID: null}) },
                        { label: "Yes", onClick: () => this.handleDelete() }
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this port ?</p>
                </Dialog>
            </div>
        )
    }
}

let PortsTableSematable = sematable(PORTS_TABLE, PortsTable, columns, {
    defaultPageSize: -1,
    autoHidePagination: true,
    showPageSize: false
});

/**
 * Wrapper
 */
class Ports extends React.Component {

    componentDidMount() {
        this.props.dispatch(portActions.fetchPorts(true));
    }

    render() {
        if (this.props.loading || this.props.ports === undefined) {
            return (<div><Loader/></div>)
        }

        return (
            <div>
                <h1>{this.props.item.title}</h1>
                <Button type="button" floating onClick={() => this.props.handleClick(PortForm, {item: null, selectNewItem: false}, creationActions.destroyingnewlyCreatedPort())} icon="add" className="add-button"/>
                <PortsTableSematable {...this.props} data={this.props.ports} />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        ports: state.port.ports,
        loading: state.port.loading,
        deletingPort: state.port.deleting
    })
})(Ports);


// WEBPACK FOOTER //
// ./src/components/prefTables/Ports.js